import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  MenuItem,
  Menu,
} from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import { MdAccountCircle } from "react-icons/md";
import { AiOutlineShoppingCart, AiOutlineBorderlessTable } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Badge from "@mui/material/Badge";
import { signout } from "../store/reducers/userReducer";
import { Col, Row } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function Header() {
  const cart = useSelector((state) => state.cart);
  const userSignin = useSelector((state) => state.userSignin);
  const { cartItems } = cart;
  const { userInfo } = userSignin;
  const dispatch = useDispatch();
  const signoutHandler = () => {
    dispatch(signout());
  };
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className="bg-warning">
        <Toolbar>
          <Typography variant="h5" className={classes.title}>
            <Link className="tdnone text-dark" to="/">
              <img
                src="https://z.nooncdn.com/s/app/com/noon/images/logos/noon-black-en.svg"
                alt="imgLogo"
              />
            </Link>
          </Typography>
          <div>
            <Row className="align-items-center">
              <Col md={4} xs={4}>
                <Link className="tdnone text-dark px-lg-2" to={`/cart`}>
                  <Tooltip title="Cart">
                    {cartItems.length > 0 ? (
                      <IconButton
                        aria-label="current-cart"
                        aria-controls="menu-appbar"
                        color="inherit"
                      >
                        <Badge badgeContent={cartItems.length} color="primary">
                          <AiOutlineShoppingCart />
                        </Badge>
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="current-cart"
                        aria-controls="menu-appbar"
                        color="inherit"
                      >
                        <Badge badgeContent={0} showZero color="primary">
                          <AiOutlineShoppingCart />
                        </Badge>
                      </IconButton>
                    )}
                  </Tooltip>
                </Link>
              </Col>
              <Col md={8} xs={8}>
                {userInfo ? (
                  <>
                    <Tooltip title="Account">
                      <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="default"
                        size="medium"
                      >
                        <MdAccountCircle />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={anchorEl}
                      getContentAnchorEl={null}
                      id="menu-appbar"
                      open={open}
                      onClose={handleClose}
                      onClick={handleClose}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      <MenuItem onClick={handleClose}>
                        <Link className="tdnone text-dark" to='/profile'>
                          <MdAccountCircle /> &nbsp; {userInfo.name}
                        </Link>
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <Link className="tdnone text-dark" to="/orderhistory">
                          <AiOutlineBorderlessTable /> &nbsp; Order History
                        </Link>
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <Link
                          className="tdnone text-dark"
                          to="/"
                          onClick={signoutHandler}
                        >
                          <FiLogOut /> &nbsp; Log out
                        </Link>
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  <Link className="tdnone text-dark" to="/signin">
                    <span className="pr-1">
                      <MdAccountCircle size={"1.1em"} />
                    </span>
                    <span className="login">Log in</span>
                  </Link>
                )}
              </Col>
            </Row>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
